import API from '@/API/API'

const AdminAddServiceStore = {
  api: API,
  state: {
    currentUserId: '',
    editing: false,
    serviceId: 0,
    form: {
      active: '',
      accountRequired: '',
      archiveAfterCompletion: '',
      removeAfter6Months: ''
    }
  },
  createService: function (success, error) {
    let self = this;
    this.api
      .createAdminService(this.state.form)
      .then(function (res) {
        if (res.data) {
          let data = res.data
          if (data.error) {
            error(data.error)
          } else {
            success();
          }
        } else {
          error("Failed to create service");
        }
      })
      .catch(e => {
        error('An Error Occurred')
      })
  },
  fetchService: function (success, error) {
    let self = this;
    this.api
      .getService(this.state.serviceId)
      .then(function (res) {
        if (res.data) {
          let data = res.data
          if (data.error) {
            error(data.error)
          } else {
            const service = data.service;
            self.populateForm(service,[
              "name", "active", "accountRequired", "archiveAfterCompletion","removeAfter6Months","description"
            ]);
            success(service);
          }
        } else {
          error("Failed to get service");
        }
      })
      .catch(e => {
        error('An Error Occurred')
      })
  },
  populateForm: function(service, fields){
    fields.forEach(field => {
      this.state.form[field] = service[field];
    });
  },
  updateService: function (success, error) {
    let self = this;
    this.api
      .updateAdminService(this.state.serviceId,this.state.form)
      .then(function (res) {
        if (res.data) {
          let data = res.data
          if (data.error) {
            error(data.error)
          } else {
            success();
          }
        } else {
          error("Failed to update service");
        }
      })
      .catch(e => {
        error('An Error Occurred')
      })
  }
}

export default AdminAddServiceStore



// WEBPACK FOOTER //
// ./src/components/admin/AdminAddServiceStore.js